import { useContext } from 'react'

import TripContext from 'tripPlanner/contexts/TripContext'
import { PublicTripItem } from 'tripPlanner/types/publicTrip'
import {
  AttractionItem,
  EventItem,
  NoteItem,
  RestaurantBarItem,
  ThingToDoItem,
  TripItem,
} from 'tripPlanner/types/tripItem'

export const itemTypesWithNoEndDate = [
  'ATTRACTION',
  'RESTAURANT_BAR',
] satisfies Array<
  Exclude<TripItem, { endDate: moment.Moment | undefined }>['type']
>

export function itemIsInItinerary(
  item: TripItem | PublicTripItem,
  trip: { startDate?: moment.Moment, endDate?: moment.Moment } | undefined,
): boolean {
  return (
    !!item.startDate &&
    !!trip?.startDate &&
    !!trip.endDate &&
    item.startDate.isBetween(trip.startDate, trip.endDate, 'day', '[]')
  )
}

export function isCustomSingleDateItem(
  item: TripItem,
): item is
  | AttractionItem
  | EventItem
  | RestaurantBarItem
  | ThingToDoItem
  | NoteItem {
  return (
    item.type === 'ATTRACTION' ||
    item.type === 'EVENT' ||
    item.type === 'RESTAURANT_BAR' ||
    item.type === 'THING_TO_DO' ||
    item.type === 'NOTE'
  )
}

export function useItemOutsideOfTripDates(item: TripItem) {
  const tripContext = useContext(TripContext)
  if (tripContext?.startDate && tripContext?.endDate) {
    let isInValidStartDate = false
    let isInValidEndDate = false
    if (item.startDate) {
      isInValidStartDate =
        item.startDate < tripContext.startDate ||
        item.startDate > tripContext.endDate
    }
    if ('endDate' in item && item.endDate) {
      isInValidEndDate =
        item.endDate < tripContext.startDate ||
        item.endDate > tripContext.endDate
    }
    return isInValidStartDate || isInValidEndDate
  }
  return false
}
